import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-d08a7144"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "login-hint-dialog"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "请先登录再完成下载操作！", -1));

const _hoisted_3 = {
  class: "dialog-footer"
};
import { ref } from 'vue';
import { USER_LOGIN_IP } from '@/service/request/config.js';
export default {
  __name: 'login-hint-dialog',

  setup(__props, {
    expose: __expose
  }) {
    const dialogVisible = ref(false);

    const handleToLogin = () => {
      const currentUrl = window.location.href;
      window.location.href = USER_LOGIN_IP + '/login?org=comentropy&app=download_center&goto=' + currentUrl; // window.location.href =
      //   ' https://www.uniaccount.org/login?org=comentropy&app=download_center&goto=' +
      //   currentUrl
    };

    __expose({
      dialogVisible
    });

    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => dialogVisible.value = $event),
        title: "提示",
        width: "500px",
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_3, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: handleToLogin
        }, {
          default: _withCtx(() => [_createTextVNode(" 前往登录 ")]),
          _: 1
        })])]),
        default: _withCtx(() => [_hoisted_2]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }

};